import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { HowItWorksHero } from "@/components/how-it-works/HeroSection";
import { ProblemSection } from "@/components/how-it-works/ProblemSection";
import { SystemSection } from "@/components/how-it-works/SystemSection";
import { DifferentiatorSection } from "@/components/how-it-works/DifferentiatorSection";
import { ExampleFlowSection } from "@/components/how-it-works/ExampleFlowSection";
import { CTASection } from "@/components/how-it-works/CTASection";

const HowItWorks = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <HowItWorksHero />
        <ProblemSection />
        <SystemSection />
        <DifferentiatorSection />
        <ExampleFlowSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorks;
